/**
 * request.js
 * Written by: Connor Taylor
 */

import axiosRequest from 'axios';
import { API_BASE } from '../../../../utils';

axiosRequest.defaults.xsrfHeaderName = `X-CSRFToken`;
axiosRequest.defaults.xsrfCookieName = `csrftoken`;

const request = (url, method, data = undefined, params = null) => { // eslint-disable-line
  return (dispatch, getState) => {
    const authHeader = getState().user.JWT ? `JWT ${getState().user.JWT}` : ``;
    return axiosRequest({
      url: `${API_BASE}${url}`,
      method,
      data,
      params,
      headers: {
        'Content-Type': `application/json`,
        Authorization: authHeader,
      },
    });
  };
};

export default request;
